import React from 'react'
import { useMediaQuery } from '@mui/material'

import LargeScreen from '../screens/LargeScreen'
import SmallScreen from '../screens/SmallScreen'

function ChatComponent() {

    const isMobile = useMediaQuery('(max-width:670px)');
    console.log(isMobile)

    return (
        <div>
            {isMobile  ?
                // <></>

                <SmallScreen />
                :
                // <></>
                <LargeScreen />
            }

        </div >
    )
}

export default ChatComponent